var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCow = function SvgCow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2151_70339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 11.6466C16.875 10.2674 16.1279 9.04731 14.9538 8.41075C15.7543 7.34982 16.3413 6.0767 16.3413 4.5914C16.3413 4.06093 16.3413 3.53047 16.0745 3V3.05305C15.4341 5.59928 13.0861 7.24373 10.4178 7.24373H9.45721C6.78894 7.24373 4.3875 5.59928 3.80048 3.05305V3C3.53365 3.53047 3.53365 4.06093 3.53365 4.5914C3.53365 6.0767 4.12067 7.34982 4.92115 8.4638C3.74712 9.10036 3 10.2674 3 11.6466C3.85385 11.6466 4.65433 11.3283 5.29471 10.8509L5.88173 15.6251C6.04183 16.8982 7.10913 17.8 8.3899 17.8H11.4851C12.7659 17.8 13.8332 16.8452 13.9933 15.6251L14.5803 10.8509C15.2207 11.3814 16.0212 11.6466 16.875 11.6466Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81567 14.7939H13.2907",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2151_70339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cow.b3fc9c8ae30f7264cc4d0b0e586117da.svg";